import { Component, NgModule, ComponentRef } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { NgxModalContainerComponent } from '../ngx-cm-components/ngx-modal-container/ngx-modal-container.component';

export class NgxCmModalContext {
    constructor(title: string, componentContext: NgxCmComponentContext, size: string, height = 'auto') {
        this.Title = title;
        this.ComponentContext = componentContext;
        this.Size = size;
        this.Height = height;
    }

    Title: string;
    ComponentContext: NgxCmComponentContext;
    Size: string;
    Height: string;
    ComponentContainerRef: ComponentRef<NgxModalContainerComponent>;
}

export class NgxCmComponentContext {
    private Subject: Subject<any>;

    constructor(component: any, moduleId: string, path: string, input: NgxCmComponentInput[], output: NgxCmComponentOutput[]) {
        this.Component = component;
        this.ModuleId = moduleId;
        this.Subject = new Subject();
        this.Input = input;
        this.Output = output;
        this.Path = path;
    }

    Component: any;
    ModuleId: string;
    Output: NgxCmComponentOutput[];
    Input: NgxCmComponentInput[];
    Path: string;

    public changes(): Observable<any> {
        return this.Subject.asObservable();
    }

    public TriggerClose(value: any): void {
        this.Subject.next(value);
    }

    public getOutput(name: string) {
        let output = this.Output.filter(o => o.Name == name);
        if (output.length) {
            return output[0].changes();
        }
    }
}

export class NgxCmComponentInput {
    constructor(name: string, value: any) {
        this.Name = name
        this.Value = value
    }

    Name: string
    Value: any
}

export class NgxCmComponentOutput {
    private subject: Subject<any>;

    constructor(name: string, closeOnEmit?: boolean) {
        this.subject = new Subject();
        this.Name = name;
        this.Value = this.subject.asObservable();
        this.CloseOnEmit = closeOnEmit;
    }

    Name: string
    Value: any
    CloseOnEmit: boolean

    public Trigger(value: any): void {
        this.subject.next(value);
    }

    public changes() {
        return this.subject.asObservable();
    }
}